import { TypeChauffageEnum } from 'enums/typeChauffageEnum';
import { ContactFunction } from 'views/soumission-de-dossier/types/contact';

export default {
  translation: {
    locale: 'fr-FR',
    'shared.french': 'Français',
    'app.name': 'Espace Partenaire Hellio',
    'auth.hero': 'Bienvenue sur votre\nEspace Partenaire',
  },
  global: {
    password: 'Mot de passe',
    email: 'E-mail',
    phone: 'Téléphone',
    logout: 'Déconnexion',
    cancel: 'Annuler',
    required: 'Ce champ est obligatoire.',
    internet_connexion_error:
      'Une erreur inattendue s’est produite. Veuillez réessayer plus tard.',
    'email.required': 'Veuillez renseigner une adresse e-mail valide.',
    session_expired: 'Votre session a expiré. Veuillez vous reconnecter.',
    previews: 'Précédents',
    back: 'Précédent',
    next: 'Suivant',
    yes: 'Oui',
    no: 'Non',
    date: 'Date',
    mr: 'Monsieur',
    mrs: 'Madame',
    chargement: 'Chargement…',
    delete: 'Supprimer',
    invalid_email: 'Veuillez renseigner une adresse e-mail valide.',
    email_no_accents:
      'Email invalide : accents et caractères spéciaux non autorisés',
    invalid_phone_number: 'Veuillez renseigner un numéro de téléphone valide.',
    revenu_entre: '{{min}} à {{max}} €',
    revenu_superieur: 'Supérieur à {{min}} €',
    type_acceptes: '{{type}} de fichiers acceptés : ',
    infos_generales: 'Informations générales',
    voir_plus: 'Voir plus',
    voir_moins: 'Voir moins',
    reduire: 'Réduire',
    fermer: 'Fermer',
    loading: 'Chargement…',
    months: {
      1: 'Janvier',
      2: 'Février',
      3: 'Mars',
      4: 'Avril',
      5: 'Mai',
      6: 'Juin',
      7: 'Juillet',
      8: 'Août',
      9: 'Septembre',
      10: 'Octobre',
      11: 'Novembre',
      12: 'Décembre',
    },
  },
  filesize: {
    symbols: {
      iec: {
        bytes: {
          B: 'o',
          KiB: 'Kio',
          MiB: 'Mio',
          GiB: 'Gio',
          TiB: 'Tio',
          PiB: 'Pio',
          EiB: 'Eio',
          ZiB: 'Zio',
          YiB: 'Yio',
        },
      },
      jedec: {
        bytes: {
          B: 'o',
          KB: 'Ko',
          MB: 'Mo',
          GB: 'Go',
          TB: 'To',
          PB: 'Po',
          EB: 'Eo',
          ZB: 'Zo',
          YB: 'Yo',
        },
      },
    },
  },
  statuts_dossier: {
    EtudeEnCours: 'Étude en cours',
    OffreEmise: 'Offre émise',
    ChantierEnCours: 'Chantier en cours',
    PieceEnAttente: 'Pièces de fin de chantier en attente',
    Recu: 'Reçu',
    EnAttenteDeControle: 'En attente bureau de contrôle',
    Incomplet: 'Dossier non conforme',
    Valide: 'Dossier validé',
    PrimeVersee: 'Prime versée',
    Refuse: 'Refusé',
    Abandon: 'Abandon',
    EnAttenteDeSignature: 'Offre en attente de signature',
    EnCoursDeValidation: 'Dossier en cours de validation',
    InformationsRequises: 'Informations complémentaires requises',
    ChantierNonConforme: 'Chantier non conforme',
  },
  statuts_operation: {
    Eligible: 'Éligible',
    AConfirmer: 'Éligibilité à confirmer',
    NonConfirme: 'Éligibilité non confirmée à ce stade',
    Recommandations: 'Recommandations',
    Annule: 'Annulé',
    DossierEnCoursDeValidation: 'Dossier en cours de validation',
    Incomplet: 'Incomplet',
    RemisAuControle: 'Remis au Contrôle',
    PreValide: 'Pré validé',
    PrimeVersee: 'Prime versée',
    NonConforme: 'Non conforme (Qualité)',
    ActionEnCours: 'Action en cours',
    Litige: 'Litige',
    Refuse: 'Refusé',
    Retire: 'Retiré du dépôt',
  },
  login: {
    hero: 'Connexion',
    description: 'Renseignez votre adresse email et votre mot de passe',
    forgot: 'Mot de passe oublié',
    login_error: 'Votre identifiant ou votre mot de passe est incorrect',
    submit: 'Se connecter',
    token_error: 'Votre lien à expiré ou n’est plus valide',
    impersonate: 'Connecté en tant que {{name}}',
  },
  first_login: {
    hero: 'Première connexion',
    description: 'Renseignez votre mot de passe',
    success: 'Création de votre mot de passe',
    newPassword: 'Nouveau mot de passe*',
    error: 'Votre lien à expiré ou n’est plus valide',
    success_description:
      'La création de votre mot de passe a bien été prise en compte.',
    success_action: 'Me connecter',
    submit: 'Valider le mot de passe',
    same: 'Les mots de passes ne sont pas identiques',
    'confirm.password': 'Confirmer mot de passe*',
    'confirm.regex.error':
      'Le mot de passe doit contenir 8 caractères : une majuscule, un chiffre et un caractère spécial.',
    'confirm.placeholder.password': 'Confirmation du mot de passe',
  },
  change_password: {
    hero: 'Changement de mot de passe',
    newPassword: 'Nouveau mot de passe*',
    description: 'Renseignez votre nouveau mot de passe',
    submit: 'Valider le mot de passe',
    success: 'Modification du mot de passe',
    success_description:
      'La modification de votre mot de passe a bien été effectuée.',
    success_action: 'Me connecter',
    same: 'Les mots de passes ne sont pas identiques',
    'confirm.password': 'Confirmer le nouveau mot de passe*',
    'confirm.regex.error':
      'Le mot de passe doit contenir 8 caractères : une majuscule, un chiffre et un caractère spécial.',
    'confirm.placeholder.password': 'Confirmation du mot de passe',
  },
  404: {
    hero: 'Page introuvable',
    description: 'La page que vous cherchez n’existe pas ou a été déplacée.',
    back: 'Retour à l’accueil',
  },
  not_implemented: {
    hero: 'Non implémenté',
  },
  reset_password: {
    hero: 'Mot de passe oublié',
    description:
      'Veuillez saisir votre email de connexion afin de recevoir le lien de réinitialisation de votre mot de passe.',
    submit: 'Valider',
    error: 'Votre lien à expiré ou n’est plus valide',
    back: 'Retour à la connexion',
    success: 'Réinitialisation du mot de passe',
    success_title: 'Réinitialisation du mot de passe',
    success_description:
      'Nous vous avons envoyé un e-mail pour réinitialiser votre mot de passe. Pour créer votre nouveau mot de passe, il vous suffit de cliquer sur le lien contenu dans l’e-mail et d’en saisir un nouveau.<br>' +
      '<strong>Vous n’avez pas reçu cet e-mail</strong><br> Vérifiez vos courriers indésirables ou contactez : ',
    email: 'plateforme-partenaires@hellio.com',
  },
  homepage: {
    hero: 'Accueil',
  },
  contact: {
    title: 'Votre référent Hellio',
    no_contact: 'Aucun référent commercial n’est rattaché à votre compte.',
  },
  calculer_une_prime: {
    hero: 'Calculer une prime',
    description:
      'Calculez la prime Hellio associée à votre opération en quelques clics.',
    title: 'Calculateur de prime',
    champs_requis: {
      champs: 'Les champs accompagnés d’un ',
      requis: ' sont requis.',
    },
    validation: {
      valeur_inferieure:
        'Veuillez entrer une valeur inférieure ou égale à {{max}}',
      valeur_superieure:
        'Veuillez entrer une valeur supérieure ou égale à {{min}}',
    },
    operation: 'Choisissez une opération parmi la liste',
    operation_date: {
      question: 'Date prévisionnelle d’engagement de l’opération',
      required: 'Veuillez sélectionner une date.',
      information:
        'Date de signature devis, ordre de service, bon de commande ou acte d’engagement',
    },
    facteur_r: {
      tooltip:
        'Le Facteur R représente la part de la PAC dans la puissance totale de la chaufferie.\nSi la puissance totale des PAC installées est égale ou supérieure à 40 % de la puissance totale de la chaufferie après travaux, alors le facteur R = 1.',
      comment_calculer: 'Comment le calculer ?',
      modal_title: 'Méthode de calcul du Facteur R',
      modal_rule_1:
        'Si la puissance totale des PAC installées est ≥ 40 % de la puissance totale de la chaufferie après travaux → R = 1',
      modal_rule_2:
        'Si la puissance totale des PAC installées est < 40 % de la puissance totale de la chaufferie après travaux → R = puissance PAC ÷ puissance totale de la chaufferie',
      modal_default_note:
        'La valeur 1 est pré-remplie par défaut car elle correspond à la grande majorité des cas.',
    },
    code_postal_label: 'Saisissez un code postal',
    entrez_code_postal: 'Entrez un code postal',
    batiment: {
      question: 'De quel type de bâtiment s’agit-il ? ',
      required: 'Veuillez sélectionner un type de bâtiment.',
      agriccole: 'Bâtiment agricole',
      industriel: 'Bâtiment industriel',
      tertiaire: 'Bâtiment tertiaire',
      residentiel: 'Bâtiment résidentiel',
    },
    valorisation: {
      title: 'Sélectionnez la valorisation souhaitée',
      required: 'Veuillez saisir une valorisation.',
    },
    type_beneficiaire: {
      title: 'Sélectionnez le type de bénéficiaire',
      required: 'Veuillez saisir un type de bénéficiaire.',
    },
    criteres_eligibilite: 'Critères d’éligibilité',
    points_de_vigilance: 'Points de vigilance',
    mention_de_facture: 'Mentions à faire figurer sur le devis / facture',
    points_de_controle_site: 'Points de contrôle sur site',
    calculer_la_prime: 'Calculer la prime ',
    statut_precarite: {
      precaire: 'Précaire',
      modeste: 'Modeste',
      classique: 'Classique',
      non_renseigne: 'Non renseigné',
    },
    cdp_associe: {
      error: 'Erreur lors de la récupération des CDP associés',
    },
    resultat: {
      votre_situation: 'Votre situation',
      reinitialiser_ma_simulation: 'Réinitialiser ma simulation',
      type_de_batiment: 'Type de bâtiment',
      mode_de_fonctionnement_du_site: 'Mode de fonctionnement du site',
      type_operation: 'Type d’opération (FOST)',
      puissance_nominale_du_moteur: 'Puissance nominale du moteur (en Kw',
      code_postal: 'Code postal',
      montant_de_la_prime_CEE: 'Montant de la prime CEE',
      prime_MPR: 'Prime MaPrimeRénov’',
      montant_de_la_prime_MPR: 'Montant de la prime MaPrimeRénov’',
      montant_de_la_prime_description:
        'Le montant de prime estimé indiqué ici est calculé sur la base des paramètres que vous avez indiqué dans le calcul. Ce montant est conditionné au respect des critères d’éligibilité et est susceptible d’évoluer en fonction des travaux effectivement réalisés et de l’évolution des paramètres déclarés à ce stade',
      volume_de_CEE_reel: 'Volume de CEE réel',
      prime_globale: 'Prime globale',
      prime_pro: 'Prime professionnel',
      prime_beneficiaire: 'Prime bénéficiaire',
      prime_professionnel: 'Prime professionnel',
      repartition_beneficiaire_pro:
        'Répartition CEE bénéficiaire /' + ' professionnel',
      montant_max_prime:
        'Le montant maximum de la Prime Professionnel ne peut dépasser {{max}}%',
      montant_prime_rappel_warning:
        'Nous vous rappelons de faire valider votre devis avec remise par' +
        ' nos équipes spécialisées avant de le faire signer à vos clients.',
      montant_prime_rappel_warning_repartition:
        'La répartition doit respecter le montant minimal de la prime Coup de pouce versée au bénéficiaire.',
      enregistrer_ma_simulation: 'Enregistrer ma simulation',
      ajouter_une_operation: 'Ajouter une opération',
      precedent: 'Précédent',
      soumettre_mon_dossier: 'Soumettre mon dossier',
      soumettre_un_dossier: 'Soumettre un dossier',
      enregistrer_une_simulation: 'Enregistrer une simulation',
      nom_de_la_simulation: 'Nom de la simulation',
      multiple_operations:
        'Votre devis inclut-il d’autres opérations d’économie d’énergie ? <0></0> Vous avez la possibilité d’ajouter une nouvelle opération.',
      oui_jajoute_une_operation: 'Oui, j’ajoute une opération',
      non_je_soumets_mon_dossier: 'Non, je soumets mon dossier',
      veuillez_nommer_simulation: 'Veuillez nommer votre simulation',
      nom_obligatoire: 'Le nom de la simulation est obligatoire',
      nom_placeholder: 'Nom de la simulation',
      valider: 'Valider',
      confirmation_enregistrement: {
        sauvegarde_de_simulation: 'Sauvegarde de la simulation',
        simulation_bien_enregistree: 'Votre simulation a bien été enregistrée',
        simulation_probleme_enregistrement:
          'Un problème est survenu lors de l’enregistrement de votre simulation',
        acceder_historique_simulation: 'Accéder à l’historique des simulations',
      },
      error: {
        montant_prime_non_calculable:
          'Nous vous invitons à soumettre votre dossier, votre chargé de' +
          ' partenariat reviendra vers vous avec une estimation de la prime.',
      },
      revenir_a_la_calculette: 'Revenir à la calculette',
    },
    travaux_mpr: {
      type_isolation: {
        title: 'Type d’isolation',
        required: 'Veuillez sélectionner un type d’isolation.',
      },
      type_travaux_mpr: {
        title: 'Type de travaux MaPrimeRénov',
        placeholder: 'Type de travaux MaPrimeRénov',
        label: 'Saisissez un type de travaux.',
        required: 'Veuillez sélectionner un type de travaux MaPrimeRénov.',
      },
      nombre_personnes_logement_mpr: {
        title: 'Nombre de personnes dans le logement',
        required: 'Veuillez saisir le nombre de personnes dans le logement.',
      },
      revenu_fiscal_reference: {
        title: 'Revenu fiscal de référence',
        required: 'Veuillez sélectionner le revenu fiscal de référence.',
      },
      montant_travaux_ttc: {
        title: 'Montant des travaux TTC',
        required: 'Veuillez saisir le montant des travaux TTC.',
      },
    },
    logements_conventionnes: {
      title: 'La totalité des logements est conventionnée ?',
      oui: 'Oui',
      non: 'Non',
      required: 'Veuillez répondre à cette question.',
      nombre_total: {
        label: 'Nombre de logements total',
        min_error: 'Veuillez entrer une valeur supérieure ou égale à 1.',
        required: 'Ce champ est requis.',
      },
      nombre_conventionnes: {
        label: 'Nombre de logements conventionnés',
        tooltip: 'Renseignez 0 si aucun logement conventionné',
        required: 'Ce champ est requis.',
        max_error:
          'Le nombre de logements conventionnés ne peut pas dépasser le nombre total.',
      },
    },
    tabs: {
      calculer_une_prime: 'Calculateur de prime',
      historique: {
        label: 'Historique de mes simulations',
        export: 'Exporter mes simulations (.csv)',
        search_placeholder: 'Rechercher une simulation',
        table: {
          date: 'Date',
          name: 'Nom de la simulation',
          fost: {
            value: 'Type de bâtiment',
            label: 'Libellé de l’opération',
          },
          repartitionPrime: 'Répartition CEE Bénéficiaire / Professionnel',
          volume: 'Volume CEE',
          prime: 'Montant prime CEE globale',
          mpr: `Montant MaPrimeRénov'`,
          montantPrimeBenef: 'Montant prime CEE Bénéficiaire',
          montantPrimePro: 'Montant prime CEE Professionnel',
        },
      },
    },
  },
  soumettre_un_dossier: {
    hero: 'Soumission d’un dossier',
    etapes: {
      etape_1: 'Informations chantier',
      etape_2: 'Informations site',
      etape_3: 'Informations bénéficiaire',
      etape_4: 'Informations complémentaires',
      etape_5: 'Pièces justificatives',
      // Traductions pour les concessionnaires (parcours transport)
      etape_1_concessionnaire: 'Informations opération',
      etape_2_concessionnaire: 'Informations bénéficiaire',
      etape_3_concessionnaire: 'Informations complémentaires',
      etape_4_concessionnaire: 'Pièces justificatives',
    },
    champs_requis: {
      champs: 'Les champs accompagnés d’un ',
      requis: ' sont requis.',
    },
    champs: {
      startDate: {
        selectionnez_date: 'Sélectionnez une date',
        value: 'Date de début des travaux',
        invalid:
          'La date de début des travaux doit être inférieure à la date de fin des travaux',
      },
      endDate: {
        value: 'Date prévisionnelle de fin des travaux',
        value_concessionnaire:
          'Date prévisionnelle de livraison de l’équipement',
        invalid:
          'La date de fin des travaux doit être supérieure à la date de début des travaux',
      },
      buildingType: {
        label: 'Type de site',
        placeholder: 'Sélectionnez un type de site',
        options: {
          maison: 'Maison individuelle',
          appartement: 'Appartement',
          monopropriete: 'Monopropriété',
          copropriete_immatriculee: 'Copropriété immatriculée',
          copropriete_non_immatriculee: 'Copropriété non immatriculée',
        },
      },
      siteAddress: {
        address: {
          label: 'Adresse du chantier',
          placeholder: 'Adresse du chantier',
          defaultOption: {
            value: 'Je ne trouve pas l’adresse du chantier',
          },
        },
        name: {
          label: 'Nom du site du chantier',
          placeholder: 'Nom du site du chantier',
        },
        code_postal: {
          label: 'Code postal du chantier',
          placeholder: 'Code postal du chantier',
        },
        ville: {
          label: 'Ville du chantier',
          placeholder: 'Ville du chantier',
        },
        street: {
          label: 'Adresse du chantier',
          placeholder: 'Adresse du chantier',
          tooltip:
            'Les adresses proposées proviennent de la Base Adresse Nationale afin de garantir leur exactitude',
        },
        nbBuildings: {
          label: 'Nombre de bâtiments',
          placeholder: 'Nombre de bâtiments',
        },
        nbUnits: {
          label: 'Nombre de lots d’habitation',
          placeholder: 'Nombre de lots d’habitation',
        },
        typeChauffage: {
          label: 'Type de chauffage',
          placeholder: 'Sélectionnez un type de chauffage',
          options: {
            [TypeChauffageEnum.CombustibleFioul]: 'Fioul',
            [TypeChauffageEnum.Electrique]: 'Électricité',
            [TypeChauffageEnum.CombustibleGaz]: 'Gaz',
            [TypeChauffageEnum.Charbon]: 'Charbon',
            [TypeChauffageEnum.Bois]: 'Bois',
            [TypeChauffageEnum.PompeChaleur]: 'Pompe à chaleur',
            [TypeChauffageEnum.Geothermie]: 'Géothermie',
            [TypeChauffageEnum.Solaire]: 'Solaire (Biomasse)',
            [TypeChauffageEnum.Granules]: 'Granulés (Biomasse)',
            [TypeChauffageEnum.ChaleurENRMaj]: 'Réseau de chaleur ENR >50%',
            [TypeChauffageEnum.ChaleurENRMin]: 'Réseau de chaleur ENR ≤ 50%',
            [TypeChauffageEnum.PompeChaleurGaz]:
              'Pompe à chaleur + chaudière gaz',
            [TypeChauffageEnum.PompeChaleurFioul]:
              'Pompe à chaleur + chaudière fioul',
            [TypeChauffageEnum.PompeChaleurCharbon]:
              'Pompe à chaleur + chaudière charbon',
            [TypeChauffageEnum.ChaudiereBiomasseGaz]:
              'Chaudière biomasse + chaudière gaz',
            [TypeChauffageEnum.ChaudiereBiomasseFioul]:
              'Chaudière biomasse + chaudière fioul',
            [TypeChauffageEnum.ChaudiereBiomasseCharbon]:
              'Chaudière biomasse + chaudière charbon',
          },
        },
        registrationNumber: {
          label: 'N° d’immatriculation au registre des copropriétés',
          placeholder: 'N° d’immatriculation au registre des copropriétés',
        },
        distribution: {
          label: 'Mode de répartition du chauffage',
          options: {
            collective: 'Collectif',
            individual: 'Individuel',
          },
        },
        constructionYear: {
          label: 'Année de construction',
          placeholder: 'Sélectionnez une année de construction',
          options: {
            before1948: 'Avant 1948',
            before1960: 'Avant 1960',
            bw1960_1980: 'Entre 1960 et 1980',
            bw1980_2005: 'Entre 1980 et 2005',
            after2005: 'Après 2005',
          },
        },
        postalCode: {
          label: 'Code postal du chantier',
          placeholder: 'Code postal du chantier',
        },
        city: {
          label: 'Ville du chantier',
          placeholder: 'Ville du chantier',
        },
        globalRenovation: {
          hasSiteContact: {
            label:
              'Ajouter un contact utile sur site différent du gestionnaire ?',
            options: {
              true: 'Oui',
              false: 'Non',
            },
          },
          siteContact: {
            label: 'Prénom et nom du contact sur site',
            placeholder: 'Prénom et nom du contact sur site',
            defaultOption: {
              value: 'Je ne trouve pas le prénom et nom du contact sur site',
            },
            quality: {
              label: 'Qualité du contact sur site',
              options: {
                coproprietaire: ContactFunction.coproprietaire,
                gardien: ContactFunction.gardien,
                proprietaire: ContactFunction.proprietaire,
                locataire: ContactFunction.locataire,
                personnelEntretien: ContactFunction.personnelEntretien,
                autre: ContactFunction.autre,
              },
            },
            newSiteContact: {
              title: {
                label: 'Civilité du contact sur site',
              },
              lastName: {
                label: 'Nom du contact sur site',
                placeholder: 'Nom du contact sur site',
              },
              firstName: {
                label: 'Prénom du contact sur site',
                placeholder: 'Prénom du contact sur site',
              },
              email: {
                label: 'Adresse e-mail du contact sur site',
                placeholder: 'Email du contact sur site',
              },
              phone: {
                label: 'Téléphone du contact sur site',
                placeholder: 'Numéro du contact sur site',
              },
            },
          },
        },
      },
      beneficiary: {
        label: 'Type de bénéficiaire',
        options: {
          company: 'Personne morale',
          individual: 'Personne physique',
        },
        intitule: 'Informations du bénéficiaire',
      },
      siret_beneficiaire: {
        label: 'SIRET ou dénomination sociale du bénéficiaire',
        placeholder: 'SIRET ou dénomination sociale du bénéficiaire',
        defaultOption: {
          value: 'Je ne trouve pas le numéro siret du bénéficiaire',
        },
      },
      manuelSiret: {
        label: 'Saisissez le SIRET du bénéficiaire',
        placeholder: 'SIRET',
      },
      siret_entreprise_travaux: {
        label: 'SIRET ou dénomination sociale de l’entreprise de travaux',
        placeholder: 'SIRET ou dénomination sociale de l’entreprise de travaux',
        defaultOption: {
          value: 'Je ne trouve pas le SIRET de l’entreprise de travaux',
        },
      },
      contactIdParticulier: {
        label: 'Prénom et nom du contact bénéficiaire',
        placeholder: 'Prénom et nom du contact bénéficiaire',
        defaultOption: {
          value: 'Je ne trouve pas le prénom et nom du contact bénéficiaire',
        },
      },
      contactIdEntreprise: {
        label: 'Prénom et nom du référent bénéficiaire',
        placeholder: 'Prénom et nom du référent bénéficiaire',
        defaultOption: {
          value: 'Je ne trouve pas le prénom et nom du référent bénéficiaire',
        },
      },
      precariousness: {
        label: 'Statut de la précarité',
        auto_fill: 'D’après les informations renseignées préalablement',
        options: {
          non_precarious: 'Classique',
          precarious: 'Modeste',
          very_precarious: 'Précaire',
        },
        situationOccupation: {
          label: 'Situation d’occupation',
          options: {
            occupant: 'Bénéficiaire occupant',
            non_occupant: 'Bénéficiaire non occupant',
          },
        },
      },
      beneficiaireParticulier: {
        title: {
          label: 'Civilité du contact bénéficiaire',
        },
        lastName: {
          label: 'Nom du contact bénéficiaire',
          placeholder: 'Nom du contact bénéficiaire',
        },
        firstName: {
          label: 'Prénom du contact bénéficiaire',
          placeholder: 'Prénom du contact bénéficiaire',
        },
        email: {
          label: 'Adresse e-mail du contact bénéficiaire',
          placeholder: 'Email du contact bénéficiaire',
        },
        phone: {
          label: 'Téléphone du contact bénéficiaire',
          placeholder: 'Numéro du contact bénéficiaire',
        },
        isAddressSameAsSite: {
          label:
            'Est-ce que l’adresse du contact bénéficiaire est la même que l’adresse du chantier ?',
        },
      },
      beneficiaireEntreprise: {
        title: {
          label: 'Civilité du référent bénéficiaire',
        },
        lastName: {
          label: 'Nom du référent bénéficiaire',
          placeholder: 'Nom du référent bénéficiaire',
        },
        firstName: {
          label: 'Prénom du référent bénéficiaire',
          placeholder: 'Prénom du référent bénéficiaire',
        },
        email: {
          label: 'Adresse e-mail du référent bénéficiaire',
          placeholder: 'Email du référent bénéficiaire',
        },
        phone: {
          label: 'Téléphone du référent bénéficiaire',
          placeholder: 'Numéro du référent bénéficiaire',
        },
        isAddressSameAsSite: {
          label:
            'Est-ce que l’adresse du référent bénéficiaire est la même que l’adresse du chantier ?',
        },
      },
      bureau_etude: {
        siret: {
          label: 'SIRET ou dénomination sociale du bureau d’études',
          placeholder: 'SIRET ou dénomination sociale du bureau d’études',
          defaultOption: {
            value: 'Je ne trouve pas le SIRET du bureau d’études',
          },
        },
        manuel_siret: {
          label: 'Saisissez le SIRET du bureau d’études',
          placeholder: 'SIRET',
        },
        scenario_reference: {
          label: 'Référence du scénario retenu',
          placeholder: 'Scénario retenu',
        },
        certificate_number: {
          label:
            'N° de certification du bureau d’études (OPQiBi 1905, NF Habitat, AFNOR01, OPQTECC, LNE)',
          placeholder: 'Numéro de la certification',
        },
        contact: {
          label: 'Prénom et nom du contact du bureau d’études',
          placeholder: 'Prénom et nom du contact du bureau d’études',
          defaultOption: {
            value:
              'Je ne trouve pas le prénom et nom du contact du bureau d’études',
          },
          nom: {
            label: 'Nom du contact du bureau d’études',
            placeholder: 'Nom du contact du bureau d’études',
          },
          prenom: {
            label: 'Prénom du contact du bureau d’études',
            placeholder: 'Prénom du contact du bureau d’études',
          },
          email: {
            label: 'Adresse e-mail du contact du bureau d’études',
            placeholder: 'Email du contact du bureau d’études',
          },
          phone: {
            label: 'Téléphone du contact du bureau d’études',
            placeholder: 'Numéro du contact du bureau d’études',
          },
        },
      },
      maitre_oeuvre: {
        siret: {
          label: 'SIRET ou dénomination sociale du maître d’œuvre',
          placeholder: 'SIRET ou dénomination sociale du maître d’œuvre',
          defaultOption: {
            value: 'Je ne trouve pas le SIRET du maître d’œuvre',
          },
        },
        manuel_siret: {
          label: 'Saisissez le SIRET du maître d’œuvre',
          placeholder: 'SIRET',
        },
        contact: {
          label: 'Prénom et nom du contact du maître d’œuvre',
          placeholder: 'Prénom et nom du contact du maître d’œuvre',
          defaultOption: {
            value:
              'Je ne trouve pas le prénom et nom du contact du maître d’œuvre',
          },
          nom: {
            label: 'Nom du contact du maître d’œuvre',
            placeholder: 'Nom du contact du maître d’œuvre',
          },
          prenom: {
            label: 'Prénom du contact du maître d’œuvre',
            placeholder: 'Prénom du contact du maître d’œuvre',
          },
          email: {
            label: 'Adresse e-mail du contact du maître d’œuvre',
            placeholder: 'Email du contact du maître d’œuvre',
          },
          phone: {
            label: 'Téléphone du contact du maître d’œuvre',
            placeholder: 'Numéro du contact du maître d’œuvre',
          },
        },
      },

      address: {
        label: 'Adresse du bénéficiaire',
        placeholder: 'Adresse du bénéficiaire',
      },
      city: {
        label: 'Ville du bénéficiaire',
        placeholder: 'Ville du bénéficiaire',
      },
      postalCode: {
        label: 'Code postal du bénéficiaire',
        placeholder: 'Code postal du bénéficiaire',
      },

      isElectronicContract: {
        label:
          'Autoriser Hellio à envoyer des documents en signature électronique',
      },
      comment: {
        label: 'Commentaires et spécifications du projet :',
        placeholder: 'Commentaires',
      },
      SiretInfos: {
        siret_entreprise_travaux: {
          label: 'Saisissez le SIRET de l’entreprise de travaux',
          placeholder: 'SIRET de l’entreprise de travaux',
          noData: 'Je ne trouve pas l’adresse',
        },
      },
      interlocuteur: {
        label: 'Interlocuteur de l’entreprise de travaux ',
        placeholder: 'Interlocuteur de l’entreprise de travaux ',
        defaultOption: {
          value: 'Je ne trouve pas l’interlocuteur de l’entreprise de travaux',
        },
      },
      interlocuteur_infos: {
        civilite: {
          label: 'Civilité',
          mrs: 'Madame',
          mr: 'Monsieur',
        },
        lastName: {
          label: 'Nom de l’interlocuteur',
          placeholder: 'Nom de l’interlocuteur',
        },
        firstName: {
          label: 'Prénom de l’interlocuteur',
          placeholder: 'Prénom de l’interlocuteur',
        },
        function: {
          label: 'Fonction de l’interlocuteur',
          placeholder: 'Fonction de l’interlocuteur',
          options: {
            dirigeant: 'Dirigeant',
            responsable_technique: 'Responsable technique',
          },
        },
        email: {
          label: 'Adresse e-mail de l’interlocuteur',
          placeholder: 'Adresse e-mail de l’interlocuteur',
        },
        phone: {
          label: 'Téléphone de l’interlocuteur',
          placeholder: 'Téléphone de l’interlocuteur',
        },
        entreprise_name: {
          label: 'Nom de l’entreprise de l’interlocuteur',
          placeholder: 'Nom de l’entreprise de l’interlocuteur',
        },
      },
    },
    soumettre_mon_dossier: 'Soumettre mon dossier',

    modale: {
      dossier_soumis: 'Dossier soumis',
      acceder_suivi_dossiers: 'Accéder au suivi de dossiers',
      soumettre_dossier: 'Soumettre un autre dossier',
      description: 'Votre dossier a été enregistré avec succès.',
      error: 'Une erreur s’est produite lors de la soumission de votre dossier',
      en_cours_soumission:
        'Veuillez patienter, la création de votre dossier est en cours.',
    },
    fields: {
      erreurs: {
        siret_14_caracteres: 'Le SIRET doit contenir 14 caractères',
        siret_chiffres: 'Le SIRET doit être composé uniquement de chiffres',
        nombre_positif: 'Le nombre de bâtiments doit être positif',
        invalid_number: 'Le champs ne doit contenir que des chiffres',
        invalid_postal_code: 'Le code postal doit être composé de 5 chiffres',
        registration_number_format:
          'Veuillez renseigner un numéro valide. Format accepté : LL0000000. Ce numéro est composé de 2 lettres et 7 chiffres et peut se trouver sur l’annuaire du registre des copropriétés.',
      },
      siret: 'Numéro SIRET',
      siret_non_trouve: 'Je ne trouve pas le SIRET de l’entreprise de travaux',
      interlocuteur: 'Interlocuteur',
      interlocuteur_non_trouve:
        'Je ne trouve pas l’interlocuteur de l’entreprise de travaux',
    },
  },
  dossiers: {
    hero: 'Suivi de dossier',
    filter: 'Filtres',
    referent: 'Référent commercial',
    keyword: 'Référence chantier, adresse des travaux…',
    placeholder: 'Sélectionner une ou plusieurs options',
    filter_statuts: 'Filtrer par statuts',
    filter_referent: 'Filtrer par référent commercial',
    filter_pro: 'Filtrer par professionnel',
    selected_one: 'sélectionné',
    selected_other: 'sélectionnés',
    export: 'Exporter les données (.csv)',
    reset: 'Réinitialisation',
  },
  dossier_table: {
    no_data: 'Aucune donnée disponible',
    beneficiaire: 'Bénéficiaire',
    site_nom: 'Nom du site chantier',
    site_adresse: 'Adresse des travaux',
    dateModification: 'Date de mise à jour',
    chantier_dateFinTravaux: 'Date de fin des travaux',
    reference: 'Référence chantier',
    montant_primes: 'Montant des primes',
    statut: 'Statut',
    referentCommercial: 'Référent commercial',
    operation_libelle: 'Opération',
    operation_fost: 'Fiche d’opération standardisée',
    operation_montantPrime: 'Montant prime d’opération CEE',
    operation_montant_mpr: 'Montant MaPrimeRénov’',
    details: 'Voir détail',
    user: 'Raison sociale de l’installateur',
    default_type_logement: 'Logement',
    nom_site_particulier: '{{type}} de {{civilite}} {{prenom}} {{nom}}',
    aucune_operation: 'Il n’existe aucune opération pour ce dossier.',
  },
  dossier: {
    hero: 'Vue détaillée du dossier',
    history_title: 'Historique des statuts',
    reference_chantier: 'Référence chantier',
    reference_dossier: 'Référence du dossier',
    statut_dossier: 'Statut du dossier',
    referent_commercial: 'Référent commercial',
    coordonnees_beneficiaire: 'Coordonnées du Bénéficiaire',
    raison_sociale: 'Raison sociale',
    siren: 'Numéro de SIREN',
    adresse_siege: 'Adresse du siège',
    nom_beneficiaire: 'Nom du bénéficiaire',
    prenom_beneficiaire: 'Prénom du bénéficiaire',
    email_beneficiaire: 'Email du bénéficiaire',
    telephone_beneficiaire: 'Téléphone du bénéficiaire',
    chantier: 'Chantier',
    nom_site: 'Nom du site',
    adresse_chantier: 'Adresse du chantier',
    raison_sociale_installateur: 'Raison sociale de l’installateur',
    siret_installateur: 'SIRET de l’installateur',
    date_fin_travaux: 'Date de fin de travaux',
    modifier_date_fin_travaux_titre: 'Modifier la date de fin de travaux',
    modifier_date_fin_travaux_valider: 'Valider',
    modifier_date_fin_travaux_placeholder: 'Sélectionnez une date',
    modifier_date_fin_travaux_erreur:
      'Erreur lors de la mise à jour de la date de fin de travaux',
    montant_chantier: 'Montant de la prime CEE',
    modele_incitation: 'Choix du modèle d’incitation financière',
    operations: 'Opérations',
    non_conformite: 'Non-conformité',
    resoudre_contester_non_conformite:
      'Résoudre ou contester la non-conformité',
    resoudre_contester_non_conformite_description:
      'Merci de joindre un document ou un commentaire afin de lever la non-conformité.',
    contester_non_conformite_commentaire_placeholder:
      'Ajouter un commentaire ou expliquer les raisons de votre contestation',
    contester_non_conformite_commentaire: 'Commentaire',
    messagerie: 'Messagerie',
    info_operations: 'Informations concernant les opérations',
    libelle_operation: 'Libellé de l’opération',
    fiche_operation_standardisee: 'Fiche d’opération standardisée',
    fost: 'FOST',
    criteres_eligibilite: 'Critères d’éligibilité',
    points_de_vigilance: 'Points de vigilance',
    points_de_controle_contact: 'Points de contrôle par contact',
    points_de_controle_site: 'Points de contrôle sur site',
    mentions_facture: 'Mentions à faire figurer sur le devis / facture',
    montant_prime_operation: 'Montant prime d’opération CEE',
    pieces_dossier: 'Pièces du dossier',
    statut: 'Statut',
    aucun: 'Aucun',
    montant_de_la_prime_MPR: 'Montant de la prime MaPrimeRénov’',
    maprimerenov: 'MaPrimeRénov’',
    n_de_dossier: 'N° de dossier',
    documents: 'Documents',
    documents_hellio: 'Documents Hellio',
    pieces_justificatives: 'Pièces justificatives',
    no_file: 'Aucun fichier',
    tout_supprimer: 'Tout supprimer',
    avancement_dossier: 'Avancement du dossier',
  },
  litige_dossier: {
    etat_action: {
      traitement_en_cours: 'Traitement en cours',
      commentaire_contestation: 'Un commentaire a été déposé',
      details: 'Voir détails',
      termine: 'Terminé',
    },
    commentaire_contestation_modal: {
      title_one: 'Non conformité administrative',
      title_other: 'Non conformités administratives',
      commentaire: 'Commentaire',
    },
    erreurs: {
      aucun_selectionne: 'Aucun litige sélectionné.',
      upload:
        'Erreur lors de l’envoi des fichiers pour le litige {{litigeId}}.',
    },
  },
  dossier_non_conforme: {
    column_headers: {
      documents: 'Documents',
      rapport: 'Rapport',
      non_conformites_detectees: 'Non-conformités détectées',
      actions_correctives_preconisees: 'Actions correctives préconisées',
      commentaire_hellio: 'Commentaire Hellio',
      actions_a_realiser: 'Actions à réaliser',
    },
    tabs: {
      chantier: 'Non-conformités chantier',
      administrative: 'Non-conformités administratives',
      switch_label: 'Afficher les actions terminées',
    },
    non_conformites_chantier_no_content: 'Aucune non-conformité chantier',
    non_conformites_chantier_no_content_en_cours:
      'Aucune non-conformité en cours',
    non_conformites_administratives_no_content:
      'Aucune non-conformité administrative',
    non_conformites_administratives_no_content_en_cours:
      'Aucune non-conformité en cours',
    lever_non_conformites: 'Lever les non-conformités',
    modale_non_conformite_chantier: {
      attestation: 'Attestation de levée de non-conformité complétée',
      photographies: 'Photographies de l’action corrective',
      autres: 'Autres',
    },
    attestation_info:
      'Pour lever les non-conformités chantier, vous devez télécharger et compléter une attestation de levée de non-conformité.',
    telecharger_attestation: 'Télécharger l’attestation',
  },
  documents_dossier: {
    debut_travaux: 'Pièces justificatives de début des travaux',
    debut_travaux_concessionnaire:
      'Pièce justificative de début de l’opération',
    debut_travaux_hint:
      '(Devis, Ordre de service, Bon de commande, Acte d’engagement)',
    date_visite_technique: 'Date de la visite technique',
    date_edition: 'Date d’édition du document',
    montant_ttc: 'Montant TTC',
    date_debut_travaux: 'Date de début de travaux',
    date_edition_hint:
      'La date d’édition doit être la même que sur celle du document.',
    date_edition_60_days:
      'La date d’édition du document dépasse le délai autorisé de 60 jours.',
    reference_document: 'Référence du document',
    signe: 'Le document est-il signé ?',
    date_signature: 'Date de signature du document',

    preuve_role: 'Preuves du rôle actif et incitatif',
    preuve_role_hint:
      '(Accord d’incitation financière AIF, Cadre contribution)',

    fin_travaux: 'Pièces justificatives de fin des travaux',
    fin_travaux_concessionnaire: 'Pièce justificative de réalisation',
    fin_travaux_hint: '(Facture, PV de réception)',
    fin_travaux_hint_concessionnaire:
      '(achèvement des travaux / livraison de l’équipement)',

    attestation_honneur: 'Attestations sur l’honneur',

    documents_techniques: 'Certifications et docs techniques',
    documents_techniques_hint:
      '(Certifications RGE, Fiches techniques des équipements)',

    documents_operation: 'Pièces spécifiques à l’opération',

    documents_autres: 'Autres',
    documents_autres_hint: '(Avis d’imposition…)',

    upload_hint: 'Glissez vos documents ou {{action}}.',
    upload_hint_action: 'cliquez ici pour les charger',
    erreurs: {
      date_edition_devis:
        'La date d’édition du devis doit être antérieure à la date de signature.',
      date_signature_devis:
        'La date de signature doit être ultérieure à la date d’édition.',
      date_signature_rai_devis:
        'La date de signature de la preuve du rôle actif et incitatif doit être antérieure à celle de la pièce justificative de début des travaux.',
      save: 'Erreur lors de l’enregistrement des données.',
    },
    documents_mpr: 'Pièces spécifiques MaPrimeRénov’',

    upload_files: 'Déposer des fichiers',
    dossier_non_conforme:
      'Afin de déposer de nouveaux documents, veuillez corriger les non-conformités.',
    cancel_upload: 'Annuler',
    validate_upload: 'Valider',

    formats_acceptes: 'Formats de fichier acceptés : {{types}}',
    taille_acceptee:
      'Taille de fichier acceptée : maximum {{taille}} par fichier',
  },
  attachments: {
    ajouter_fichier: 'Ajouter un fichier',
    deposez_fichiers: 'ou déposez vos fichiers ici',
    error_required: 'Vous devez joindre au moins un fichier.',
    error_type: 'Le type de fichier {{type}} n’est pas autorisé.',
    error_allowed_types: 'Seuls les fichiers {{types}} sont autorisés.',
    error_size: 'Vous ne pouvez pas joindre de fichier de plus de {{size}}.',
    error_max_files_one:
      'Vous ne pouvez pas joindre plus de {{count}} fichier.',
    error_max_files_other:
      'Vous ne pouvez pas joindre plus de {{count}} fichiers.',
    download_error: 'Erreur de téléchargement',
    download_error_description:
      'Le fichier {{file}} n’a pas pu être téléchargé :',
    delete_error: 'Erreur de suppression',
    delete_error_description: 'Le fichier {{file}} n’a pas pu être supprimé :',
    upload_error: 'Erreur de chargement',
    upload_error_description: 'Le fichier {{file}} n’a pas pu être ajouté :',
  },
  attachments_info_banner: {
    type_acceptes: 'Formats de fichiers acceptés : {{types}}',
    taille_max: 'Taille de fichiers acceptée : {{size}}',
    nombre_fichiers: 'Nombre de fichiers accepté : {{max}} fichiers',
    nombre_fichiers_single: 'Nombre de fichiers accepté : {{max}} fichier',
  },
  faq: {
    title: 'FAQ',
    hero_0: 'Foire aux',
    hero_1: 'questions',
  },
  mon_compte: {
    hero: 'Mon compte',
    lastname: 'Nom',
    firstname: 'Prénom',
    email: 'E-mail',
    deconnexion: 'Se déconnecter',
  },
  resend_link_first_login: {
    title: 'Votre lien de connexion a expiré',
    action: 'Recevoir un nouveau lien',
    description:
      'Votre lien de connexion a expiré. Pour des raisons de sécurité, les liens de connexion sont valables uniquement pendant une durée limitée.',
    success_title: 'Votre lien de connexion a été envoyé par mail',
    success_description:
      '<strong>Vous n’avez pas reçu cet e-mail</strong><br> Vérifiez vos courriers indésirables ou contactez :<br>',
  },
  errors: {
    correspondance: 'Aucune correspondance trouvée pour {{objet}}.',
  },

  dashboard: {
    hero: 'Tableau de bord',
    description: 'Retrouvez le récapitulatif de l’ensemble de vos opérations.',
    legal_disclaimer:
      'Les informations figurant sur ce tableau de bord sont communiquées à titre strictement indicatif et ne constituent, en aucun cas, un engagement de paiement ni une reconnaissance de dette de la part de Hellio Solutions. Les montants éventuellement dus sont déterminés exclusivement sur la base des dossiers définitivement validés, conformément aux stipulations contractuelles et à la réglementation en vigueur.',
    dossiers: {
      title: 'Vos dossiers par statut',
      value: 'En euros',
    },
    avancement_paiements: {
      title: 'Etat d’avancement des paiements',
      value: 'En euros',
      valide: 'Dossiers validés',
      prime_versee: 'Dossiers payés',
    },
    actions_a_mener: {
      title: 'Vos actions à mener',
      voir_toutes: 'Voir toutes les actions',
    },
    paiement_primes: {
      title: 'Montant des primes payées par mois (CEE/MPR)',
      subtitle: 'En euros',
      legend_cee: 'CEE',
      legend_mpr: 'MPR',
    },
    no_data: 'Aucune donnée n’est disponible pour le moment.',
    filter: 'Filtrer par professionnel',
    filter_beneficiaire: 'Filtrer par bénéficiaire',
    max_tag_filiale_one: '+{{count}} filiale',
    max_tag_filiale_other: '+{{count}} filiales',
    max_tag_beneficiaire_one: '+{{count}} bénéficiaire',
    max_tag_beneficiaire_other: '+{{count}} bénéficiaires',
  },
  generation_document: {
    hero: 'Générer un document',
    description:
      'Générez un modèle de document à compléter pour constituer votre dossier.',
    download: 'Télécharger le modèle (format PDF)',
    document_type: {
      label: 'Type de document',
      placeholder: 'Sélectionnez le document que vous souhaitez générer',
      required: 'Le type de document est requis.',
    },
    start_date: {
      label: 'Date prévisionnelle d’engagement de l’opération',
      placeholder: 'Sélectionnez la date d’engagement de l’opération',
      information:
        'Date de signature devis, ordre de service, bon de commande ou acte d’engagement',
      required: 'La date d’engagement de l’opération est requise.',
    },
    secteur: {
      label: 'Type de batiment',
      required: 'Le type de batiment est requis.',
    },
    fost: {
      label: 'Choisissez une opération parmi la liste',
      placeholder: 'Choisissez une opération parmi la liste',
      required: 'L’opération est requise.',
    },
    situation_beneficiaire: {
      label: 'Volet spécifique',
      placeholder: 'Sélectionnez le volet spécifique',
      required: 'Le volet spécifique est requis.',
    },
    RAI: {
      label: 'Paiement de la prime',
      required: 'Le paiement de la prime est requis.',
      options: {
        RAI31: '3.1 Remise sur devis et facture',
        RAI33: '3.3 Paiement direct au bénéficiaire',
      },
    },
    success_title:
      'Votre document est complet, vous pouvez le télécharger et l’imprimer. Vous pourrez ensuite le signer.',
  },
  gestion_leads: {
    title: 'Gestion de leads',
    proposition: 'Proposition de leads',
    suivi: 'Suivi de leads',
    search: {
      placeholder_proposition: 'Rechercher par code postal, ville',
      placeholder_suivi: 'Rechercher par contact, code postal, ville',
      no_results: 'Aucun résultat pour "{{keyword}}"',
    },
    table: {
      date: 'Date',
      contact: 'Contact',
      adresse: 'Adresse',
      operations: 'Opérations',
      statut: 'Statut',
      actions: 'Actions',
      accepter: 'Accepter',
      refuser: 'Refuser',
      expiration: 'Ce lead expire le {{date}}',
      empty_title: 'Aucune lead n’est disponible pour le moment.',
      empty_description: 'Les propositions arriveront prochainement.',
    },
    suivi_table: {
      empty_title: "Aucune lead n'est disponible pour le moment.",
      empty_description: 'Les propositions arriveront prochainement.',
    },
    statut_filter: {
      label: 'Statut',
      reset: 'Réinitialiser',
      more_selected: '+{{count}}..',
    },
    accepter_modal: {
      title: 'Êtes-vous sûr(e) d’accepter le lead ?',
      operation: 'Opération :',
      code_postal: 'Code postal :',
      ville: 'Ville :',
      repondre_plus_tard: 'Je réponds plus tard',
      confirmer: 'Oui, j’accepte',
    },
    success_modal: {
      title: 'Un nouveau lead a été rajouté',
      description:
        'Vous pouvez retrouver votre lead dans l’onglet "Suivi de leads".',
      cta: 'Accéder au suivi des leads',
    },
    loading: 'Chargement…',
    error_modal: {
      title: 'Un problème est survenu',
      description:
        'L’opération a échoué. Veuillez réessayer ou contacter le support.',
      retry: 'Réessayer',
      close: 'Fermer',
    },
    refuser_modal: {
      title: 'Êtes-vous sûr(e) de refuser le lead ?',
      warning: 'Ce contact ne sera plus disponible dans le suivi de leads.',
      confirmer: 'Oui, je refuse',
      success_title: 'Le lead a été refusé.',
      success_description:
        'Ce lead ne vous sera plus proposé et a bien été retiré de votre liste.',
      success_close: 'Fermer',
    },
    detail: {
      loading: 'Chargement…',
      not_found: 'Lead introuvable',
      error_title: 'Erreur',
      error_subtitle:
        'Une erreur est survenue lors du chargement du lead. Veuillez réessayer.',
      back: 'Retour sur mes leads',
      lead: 'Lead',
      adresse: 'Adresse',
      email: 'Email',
      telephone: 'Téléphone',
      right_panel_placeholder: '',
      tabs: {
        suivi_actions: 'Suivi des actions',
        simulation: 'Simulation',
      },
      soumettre_dossier: 'Soumettre un dossier',
      activities: {
        empty: 'Aucune activité pour le moment.',
        lead_accepte_hint:
          'L’acceptation du lead est terminée — il apparaît dans votre suivi. L’étape suivante est de le contacter.',
        date_label: 'Date',
        modifier: 'Modifier',
        il_y_a_heures: 'il y a {{count}} heure',
        il_y_a_heures_plural: 'il y a {{count}} heures',
        il_y_a_jours: 'il y a {{count}} jour',
        il_y_a_jours_plural: 'il y a {{count}} jours',
        il_y_a_moins_1h: "il y a moins d'une heure",
        motif_abandon: "Motif d'abandon",
        motif_pause: 'Motif de la mise en pause',
        lead_reactiv_hint:
          'Le lead a été réactivé et reprend son cours normal.',
      },
      mettre_en_pause: 'Mettre en pause',
      reactiver_lead: 'Réactiver le lead',
      abandon: 'Abandon',
      abandon_drawer: {
        title: 'Abandon du lead',
        motif_label: "Indiquez le motif de l'abandon",
        confirmer: 'Confirmer',
        success_message: 'Votre lead a bien été abandonné',
        error_message: "Erreur lors de l'abandon du lead",
      },
      pause_drawer: {
        title: 'Mise en pause du lead',
        motif_label: 'Indiquez le motif de la mise en pause',
        reactiver_label: 'À réactiver ultérieurement',
        date_reactivation_label: 'Date de réactivation du lead',
        confirmer: 'Confirmer',
        success_message: 'Votre lead a bien été mis en pause',
        success_message_with_date:
          'Votre lead a bien été mis en pause. Il sera réactivé le {{date}}.',
        error_message: 'Erreur lors de la mise en pause du lead',
      },
      confirm_pause_modal: {
        title: 'Mettre le lead en pause',
        warning:
          "En mettant ce lead en pause, sa réactivation ultérieure remettra votre suivi à zéro : vous repartirez de l'étape « À contacter ».",
        revenir: 'Revenir au formulaire',
        confirmer: 'Oui, mettre en pause',
      },
      confirm_abandon_modal: {
        title: 'Vous souhaitez abandonner le lead ?',
        warning:
          'Le lead sera clôturé et plus aucune nouvelle action ne sera possible.',
        revenir: "Revenir à l'action précédente",
        abandonner: 'Abandonner le lead',
      },
      confirm_reactivate_modal: {
        title: 'Réactiver le lead',
        warning: 'Êtes-vous sûr de vouloir réactiver ce lead ?',
        garder_en_pause: 'Non, je garde le lead en pause',
        reactiver: 'Oui, je réactive le lead',
      },
      reactivate_success: 'Votre lead a bien été réactivé',
      reactivate_error: 'Erreur lors de la réactivation du lead',
      timeline: {
        tooltip: 'Indiquer la prochaine action',
      },
      advance: {
        confirm_title: "Confirmation de l'action : {{subject}}",
        next_title: 'Prochaine action : {{subject}}',
        next_title_devis_signe: 'Prochaine action : Enregistrer une vente',
        champs_obligatoires:
          'Les champs signalés par un astérisque <1>*</1> sont obligatoires',
        completez: 'Complétez les informations',
        date: 'Date',
        commentaires: 'Commentaires',
        commentaires_placeholder: "Précisez l'action",
        placeholder_date: 'Sélectionner une date',
        placeholder_select: 'Sélectionner une option',
        placeholder_montant: 'Saisir un montant',
        date_future_error: 'La date ne peut pas être dans le futur',
        date_relance_after_action:
          "La date de relance doit être postérieure à la date de l'action",
        date_relance_tomorrow_minimum:
          'La date de relance doit être au minimum demain',
        date_reactivation_after_action:
          'La date de réactivation doit être postérieure à la date de mise en pause',
        date_reactivation_tomorrow_minimum:
          'La date de réactivation doit être au minimum demain',
        confirmer_et_ajouter: 'Confirmer et ajouter une nouvelle action',
        valider: 'Valider',
        relancer_ulterieurement: 'À relancer ultérieurement',
        date_relance: 'Date de relance',
        typologie_travaux: 'Opérations',
        montant_ttc: 'Montant TTC',
        date_signature: 'Date de signature',
        date_previsionnelle_fin: 'Date prévisionnelle de fin de chantier',
        success_message: 'Votre nouvelle action a bien été ajoutée',
        error_message: 'Erreur lors de la mise à jour du lead',
      },
      devis_signe_modal: {
        title: 'Bravo, vous avez enregistré une vente !',
        warning:
          'Le lead sera clôturé et plus aucune nouvelle action ne sera possible. Si votre devis contient une remise de prime, vous pouvez soumettre votre dossier',
        soumettre: 'Oui, je soumets mon dossier',
        pas_de_remise: 'Non, le devis ne contient pas de remise',
      },
      edit: {
        title: "Modification de l'action : {{subject}}",
        success_message: 'Votre action a bien été modifiée',
        error_message: 'Erreur lors de la modification',
      },
      cancel_modal: {
        title: 'Vous souhaitez annuler les modifications ?',
        warning:
          'Si vous ne complétez pas la nouvelle action, les informations ajoutées précédemment seront perdues',
        confirmer: "Je confirme l'annulation",
        continuer: 'Je continue mes modifications',
      },
      chantier: {
        title: 'Informations chantier',
        empty: 'Aucune information chantier disponible.',
        type_logement: 'Type de logement',
        travaux_prevus: 'Travaux prévus',
        situation_occupant: "Situation de l'occupant",
        nombre_personnes: 'Nombre de personnes dans le logement déclaré',
        revenu_fiscal: 'Revenu fiscal de référence déclaré',
        energie_chauffage: 'Énergie de chauffage actuelle',
        pompe_chaleur: 'Pompe à chaleur à installer',
        usage_pac: 'Usage pompe à chaleur',
        surface_isoler: 'Surface à isoler (m²)',
        surface_logement: 'Surface du logement (m²)',
      },
    },
    calculette: {
      title: 'Calculette de prime',
      required_hint:
        'Les champs signalés par un astérisque * sont obligatoires',
      required_hint_before: 'Les champs signalés par un astérisque ',
      required_hint_after: ' sont obligatoires',
      loading: 'Chargement des simulations…',
      hydrate_error:
        'Impossible de charger les simulations existantes. Vous pouvez continuer en étape 1.',
      quit: 'Quitter',
      quit_modal: {
        title: 'Êtes-vous sûr de vouloir quitter le parcours ?',
        warning: 'Les informations renseignées précédemment seront perdues.',
        quit: 'Quitter',
        resume: 'Reprendre',
      },
      stepper: {
        step1: 'Paramètres généraux',
        step2: 'Sélection des opérations',
        step3: 'Résultat de la prime',
      },
      step1: {
        quit: 'Quitter',
        continue: 'Continuer',
        date_label: "Date prévisionnelle de l'opération",
        date_placeholder: 'JJ/MM/AAAA',
        secteur_label: 'De quel type de site s’agit-il ?',
        secteur_agricole: 'Bâtiment agricole',
        secteur_industriel: 'Bâtiment industriel',
        secteur_tertiaire: 'Bâtiment tertiaire',
        secteur_residentiel: 'Bâtiment résidentiel',
        beneficiaire_label: 'Sélectionnez le type de bénéficiaire',
        personne_physique: 'Personne physique',
        personne_morale: 'Personne morale',
        reset_ops_modal: {
          title: 'Vous souhaitez modifier les informations ?',
          warning:
            'Les opérations sélectionnées seront abandonnées et la simulation sera réinitialisée.',
          cancel: 'Non, je retourne à la saisie',
          confirm: 'Oui, je modifie et réinitialise',
        },
      },
      step2: {
        title: 'Ajouter une ou plusieurs opérations',
        section_title: 'Ajouter une opération ou plusieurs opérations',
        add_operation: 'Ajouter une opération',
        add_first_operation: 'Ajouter une première opération',
        add_new_operation_link: 'Ajouter une nouvelle opération',
        new_operation_header: 'Nouvelle opération',
        empty_hint: 'Aucune opération ajoutée pour le moment.',
        valorisation_label: 'Sélectionnez la valorisation souhaitée',
        fost_list_loading: 'Chargement des opérations…',
        save_operation: "Enregistrer l'opération",
        cancel_operation: "Annuler l'opération",
        delete_operation: "Supprimer l'opération",
        expand: 'Ouvrir',
        collapse: 'Réduire',
        prev: 'Précédent',
        simulate: 'Simuler ma prime',
        operations_count_one: '{{count}} opération ajoutée',
        operations_count_other: '{{count}} opérations ajoutées',
        simulate_error:
          'Erreur lors du calcul de la prime. Veuillez réessayer.',
        delete_error: 'Erreur lors de la suppression de la simulation.',
        delete_confirm_modal: {
          title: 'Supprimer cette opération ?',
          description:
            'Cette action est définitive. Si une simulation existe déjà pour cette opération, elle sera également supprimée.',
          cancel: 'Annuler',
          confirm: 'Supprimer',
        },
      },
      step3: {
        operations_title_one: 'Détails des opérations ({{count}})',
        operations_title_other: 'Détails des opérations ({{count}})',
        result_title: 'Résultat du calcul',
        edit_global: 'Modifier',
        restart: 'Recommencer',
        prev: 'Précédent',
        save_and_return: 'Enregistrer et revenir à la vue détaillée',
        save_and_submit: 'Enregistrer et soumettre un dossier',
        submit_dossier: 'Soumettre un dossier',
        save_success: 'Enregistrement effectué.',
        save_error: "Erreur lors de l'enregistrement",
        edit_operation: "Modifier l'opération",
        delete_operation: "Supprimer l'opération",
        restart_modal: {
          title: 'Souhaitez-vous recommencer la simulation ?',
          warning:
            'Toutes les opérations simulées et les résultats seront perdus.',
          cancel: 'Annuler',
          confirm: 'Recommencer',
        },
        detail: {
          type_batiment: 'Type de bâtiment',
          date_previsionnelle: "Date prévisionnelle d'engagement",
          type_operation: "Type d'opération (FOST)",
          type_operation_mpr: "Type d'opération MaPrimeRénov",
          surface_isolant: "Surface de l'isolant",
          nb_personnes: 'Nombre de personnes dans le logement',
          revenu_fiscal: 'Revenu fiscal de référence',
          volume_cee: 'Volume CEE',
          prime_cee: 'Montant prime CEE',
          prime_mpr: "Montant MaPrimeRénov'",
          prime_globale: 'Prime globale',
        },
        result: {
          operations_count_one: '{{count}} opération calculée',
          operations_count_other: '{{count}} opérations calculées',
          prime_globale: 'Prime globale',
          mpr: "MaPrimeRénov'",
          montant_prime: 'Montant de prime',
          volume_cee: 'Volume de CEE',
          prime_cee: 'Montant de la prime',
          prime_pro: 'Prime Professionnel',
          prime_pro_tooltip:
            'La prime professionnel correspond à la part en pourcentage (%) de la prime CEE que vous conservez en tant que professionnel.',
          prime_beneficiaire: 'Prime Bénéficiaire',
          prime_beneficiaire_tooltip:
            'La prime bénéficiaire correspond à la part en pourcentage (%) de la prime CEE reversée au bénéficiaire.',
          max_prime_pro_info:
            'Le montant maximum de la Prime Professionnel ne peut dépasser {{max}} % de la prime CEE.',
          coup_de_pouce_warning:
            'La répartition doit respecter au minimum {{min}} % de la prime CEE au titre du dispositif Coup de pouce pour la part bénéficiaire.',
          reverse_pct_prefix: 'Je reverse',
          reverse_pct_suffix: 'de la prime au Bénéficiaire',
          disclaimer:
            "Le montant de prime estimé ici est calculé sur la base des paramètres que vous avez indiqué dans le calcul. Ce montant est conditionné au respect des critères d'éligibilité CEE et est susceptible d'évoluer en fonction des travaux effectivement réalisés et de l'évolution des paramètres déclarés à ce stade.",
        },
      },
      simulation_tab: {
        empty_title: 'Aucune simulation n’est enregistrée dans le dossier',
        empty_description: 'Commencez dès maintenant à calculer vos primes',
        calculer: 'Calculer une prime',
        col_operation: 'Opération',
        col_prime_cee: 'Montant prime CEE',
        col_prime_mpr: "Montant MaPrimeRénov'",
        prime_globale: 'Prime globale',
      },
    },
  },
  supportForm: {
    // Page principale du formulaire
    title: 'Demande de support',
    submit: 'Soumettre ma demande',
    requestSubmitted: 'Votre demande de support a été soumise avec succès',
    requestFailed:
      'Une erreur est survenue lors de la soumission de votre demande',
    checkServerRunning:
      'Vérifiez que le serveur backend est en cours d’exécution sur le port 3005',
    serverError: 'Erreur serveur',
    connectionError: 'Erreur de connexion',
    parseError: 'Erreur de format de données',

    // Champs du formulaire
    sujet: {
      label: 'Sujet',
      placeholder: 'Ex: Problème lors du calcul de prime',
      error: 'Le sujet est obligatoire (max {{max}} caractères)',
      errorMax: 'Le sujet ne peut pas dépasser {{max}} caractères',
    },
    categorie: {
      label: 'Fonctionnalité concernée',
      placeholder: 'Choisissez la fonctionnalité concernée',
      error: 'La fonctionnalité concernée est obligatoire',
      options: {
        actualite: 'Actualité',
        calculer_prime: 'Calculer une prime',
        soumission_dossier: 'Soumission de dossier',
        suivi_dossiers: 'Suivi de dossiers',
        faq: 'FAQ',
        referent_hellio: 'Coordonnées du référent Hellio',
        connexion: 'Connexion / Déconnexion / Mot de passe oublié',
        notifications: 'Notifications',
        autres: 'Autres',
      },
    },
    priorite: {
      label: 'Criticité',
      error: 'L’impact est obligatoire',
      options: {
        elevee: 'Bloquante',
        moyenne: 'Majeure',
        faible: 'Mineure',
      },
    },
    url: {
      label: 'URL concernée',
      placeholder: 'https://...',
      error: 'L’URL doit être valide',
    },
    description: {
      label: 'Description détaillée',
      placeholder:
        'Décrivez en détail le problème rencontré ou votre question. Plus vous donnez de détails, plus nous pourrons vous aider efficacement.',
      helper:
        'Merci de fournir un maximum d’informations pour un traitement rapide.',
      error: 'La description est obligatoire',
      errorMin: 'La description doit contenir au moins {{count}} caractères',
    },
    fichiers: {
      label: 'Pièces jointes',
      select: 'Sélectionner des fichiers',
      helper: 'Formats acceptés : {{extension}}\nTaille maximale : {{size}} Mo',
      error: 'Erreur sur les fichiers joints.',
      iconAlt: 'Icône pièce jointe',
      errorMaxFiles: 'Vous ne pouvez pas ajouter plus de {{max}} fichiers',
      errorMaxSize:
        'La taille totale des fichiers ne peut pas dépasser {{maxSize}} Mo',
    },

    // Page liste des demandes
    list: {
      title: 'Support client',
      newRequest: 'Nouvelle demande',
      subject: 'Sujet',
      category: 'Fonctionnalité',
      priority: 'Priorité',
      status: 'Statut',
      createdAt: 'Date de création',
      filterByStatus: 'Filtrer par statut',
      allStatuses: 'Tous les statuts',
      noRequests: 'Aucune demande de support',
      error: 'Erreur lors du chargement des demandes',
      pagination: '{{from}}-{{to}} sur {{total}} demandes',
    },

    // Page détail d'une demande
    detail: {
      backToList: 'Retour à la liste',
      category: 'Fonctionnalité concernée',
      priority: 'Priorité',
      createdAt: 'Date de création',
      url: 'URL concernée',
      description: 'Description',
      attachments: 'Pièces jointes',
      download: 'Télécharger',
      conversation: 'Conversation',
      noComments: 'Aucun message dans cette conversation',
      addComment: 'Ajouter un message',
      commentPlaceholder: 'Votre message...',
      commentRequired: 'Veuillez saisir votre message',
      commentMin: 'Le message doit contenir au moins {{count}} caractères',
      send: 'Envoyer',
      commentAdded: 'Votre message a été ajouté',
      commentError: 'Une erreur est survenue lors de l’envoi de votre message',
      downloadError: 'Erreur lors du téléchargement du fichier',
      error: 'Erreur lors du chargement de la demande',
    },
  },
};
